<template>
<div class="mainCon">
<!--  导航栏-->
<!--  banner轮播图-->
<div class="banner" id="d1">
<!--  <first-Component style="z-index: 999;position: absolute;top:0;"></first-Component>-->
  <el-carousel height="100vh"   arrow="always">
    <el-carousel-item v-for="(item,index) in imgPath" :key="index">
      <div class="text animated fadeInLeft">
<!--        <p class="bigText">{{$t('bannerText[0].title1')}}</p>-->
        <p class="bigText" style="text-align: center;width:25%;">{{$t('bannerText[0].title2')}}</p>
        <p class="smallText" style="font-family: light2;text-transform: capitalize">{{$t('bannerText[0].title3')}}</p>
        <p class="smallText" style="font-family: light2">{{$t('bannerText[0].title4')}}</p>
        <p class="smallText" style="font-family: light2">{{$t('bannerText[0].title5')}}</p>
      </div>
        <img class="navImg animated fadeIn"  :src="`http://www.pan-am.com.cn/upload/${item.PICURL}`" alt="">
    </el-carousel-item>
  </el-carousel>
</div>

<!--  关于-->
  <div class="about  wow fadeInUp">
  <div class="leftText">
   <div class="firstCon">
     <span class="title">{{$t('about.title')}}</span>
    <div class="firstLine">
      <span></span>
    </div>
   </div>
   <p class="firstP">
     {{$t('about.homeCon1')}}
   </p>
    <p style="font-family: light2">
      {{$t('about.homeCon')}}
    </p>

    <router-link to="about">   <Btn-Component :text="$t('btn')"></Btn-Component></router-link>
  </div>
    <img src="../assets/industrial-1636388.png" alt="">
  </div>

<!--  轮播图-->
<!--  <div class="visio  wow fadeInUp">-->
<!--    <img src="../assets/construction-2578410.png" alt="">-->
<!--            <div class="visioText wow fadeInLeft">-->
<!--            <p class="visioTitle">{{$t('our[0]')}}</p>-->
<!--              <p class="visioCon" style="font-family: light2">-->
<!--                {{$t('our[1]')}}-->
<!--              </p>-->
<!--            </div>-->

<!--  </div>-->

<!--  产品分类-->
  <div class="product  wow fadeInUp">
  <div class="productTitle">
   <p style="text-transform: uppercase">{{$t('product.title')}}</p>
   <div class="line">
     <span></span>
   </div>
  </div>
    <div class="fiveImg">
<!--      左侧-->
     <div class="leftImg a">
       <div class="leftCon" >
         <img src="../assets/first.png" alt="">
         <div class="leftConText">
           <p style="text-transform: uppercase">{{proList[0] && proList[0].CALLED}}</p>
           <p class="aText" style="text-transform: capitalize;font-family: light2;font-size: 16px;" >{{ proList[0] && proList[0].TEXT}}</p>
           <div @click="gotoPro(proList[0].ID,0)">
             <Btn-Component class="btn" :text="$t('btn')"></Btn-Component>
           </div>
         </div>
       </div>

       <div class="leftCon">
         <img src="../assets/second.png" alt="">
         <div class="leftConText">
           <p style="text-transform: uppercase">{{proList[1] && proList[1].CALLED}}</p>
           <p class="aText" style="text-transform: capitalize;font-family: light2;font-size: 16px;" >{{proList[1] && proList[1].TEXT}}</p>
           <div @click="gotoPro(proList[1].ID,1)">
             <Btn-Component class="btn" :text="$t('btn')"></Btn-Component>
           </div>
         </div>
       </div>
     </div>

<!--      中间-->
      <div class="centerCon" >
        <p style="text-transform: uppercase">{{proList[2] && proList[2].CALLED}}</p>
        <p class="aText" style="text-transform: capitalize;font-family: light2;font-size: 16px;" >{{proList[2] && proList[2].TEXT}}</p>
        <div @click="gotoPro(proList[2].ID,2)">
          <Btn-Component class="btn" :text="$t('btn')"></Btn-Component>
        </div>
      </div>
<!--      右侧-->
      <div class="leftImg">
        <div class="leftCon" >
          <img src="../assets/three.png" alt="">
          <div class="leftConText">
            <p style="text-transform: uppercase">{{proList[3] && proList[3].CALLED}}</p>
            <p class="aText" style="text-transform: capitalize;font-family: light2;font-size: 16px;" >{{proList[3] && proList[3].TEXT}}</p>
            <div @click="gotoPro(proList[3].ID,3)">
              <Btn-Component class="btn" :text="$t('btn')"></Btn-Component>
            </div>
          </div>
        </div>
        <div class="leftCon" >
          <img src="../assets/four.png" alt="">
          <div class="leftConText">
            <p style="text-transform: uppercase">{{proList[4] && proList[4].CALLED}}</p>
            <p class="aText" style="text-transform: capitalize;font-family: light2;font-size: 16px;" >{{proList[4] && proList[4].TEXT}}</p>
            <div @click="gotoPro(proList[4].ID,4)">
              <Btn-Component class="btn" :text="$t('btn')"></Btn-Component>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

<!--  新闻-->
  <div class="product  wow fadeInUp">
    <div class="productTitle">
      <p>{{$t('news.title')}}</p>
      <div class="line">
        <span></span>
      </div>
    </div>
  <div class="newsCon">
<div class="select">
  <ul>
    <li v-for="(item,index) in $t('news.titleList')" :key="index" @click="changeNews(index)">
      <span :style="select===index?aStyle:''">{{item}}</span>
<!--      <img :src="src">-->
      <span class="redLine" ></span>
    </li>
  </ul>
</div>
  </div>
    <div class="newsMain">
    <div class="newsItem" v-for="(item,index) in newsList" :key="index" @click="gotoNews(item.ID)">
        <img  :src="`http://www.pan-am.com.cn/upload/${item.SMALLPIC}`" alt="">
      <p class="newsTitle">{{item.TITLE}}</p>
      <p class="newsContent" style="font-family: light2">{{item.TITLE2}}</p>
<!--      <p class="newsTime">{{item.NOTETIME}}</p>-->

    </div>

    </div>

    <router-link :to="{path:'/news',query: {select: select}}">   <Btn-Component :text="$t('btn')"></Btn-Component></router-link>


  </div>

  <div class="product  wow fadeInUp">
    <div class="productTitle">
      <p style="text-transform: uppercase">{{$t('about.titleList[4]')}}</p>
      <div class="line">
        <span></span>
      </div>
    </div>
    <div class="five wow fadeInUp">
      <div class="it2" v-for="(item,index) in imgList" :key="index">
        <img :src="item" alt="">
      </div>
    </div>
  </div>
  <foot-Component @gotoTop="gotoTop"></foot-Component>
<!--  <div id="num1" style="height:1000px;width:100%;" @click="goto">-->
<!--    　<h3>{{$t("handsome")}}</h3>-->
<!--    　　<el-button @click="changeLanguage('en')">English</el-button>-->
<!--    　　<el-button @click="changeLanguage('zh')">中文</el-button>-->
<!--  </div>-->
<!--  <div id="num2" style="height:2000px;width:100%;">-->
<!--    我是二-->
<!--  </div>-->

</div>

</template>

<script>
  import { setup } from "../local/index";
  import firstComponent from  "./first"
  import footComponent from "./foot"
  import BtnComponent from "./btn"
  import Scrollbar from 'smooth-scrollbar';
  import { getPicUrl,getProductstypeUrl2,getProductsUrl,getNewsUrl } from '../util/lang'
export default {
  name: 'HelloWorld',
  data(){
    return{
      aStyle:{
        color:'red'
      },
      proList:[
        {TEXT:'',
        CALLED:''}
      ],
      imgList:[
        require("../assets/sgs.png"),
        require("../assets/iso.png"),
        require("../assets/isoO.png"),
        require("../assets/bsci.png"),
        require("../assets/oh.png"),
        require("../assets/1.png"),
        require("../assets/2.png"),
        require("../assets/3.png"),
        require("../assets/4.png"),
        require("../assets/5.png")
      ],
      newsList:[
        {imgPath:require("../assets/news.png"),title:"Shuai Fu participated in the 2019 Summer France Expo...",content:"Shuaifu participated in the 2019 Summer France Expo. There are many ...",time:"Sep.  12 . 2019"},
        {imgPath:require("../assets/news.png"),title:"Shuai Fu participated in the 2019 Summer France Expo...",content:"Shuaifu participated in the 2019 Summer France Expo. There are many ...",time:"Sep.  12 . 2018"},
        {imgPath:require("../assets/news.png"),title:"Shuai Fu participated in the 2019 Summer France Expo...",content:"Shuaifu participated in the 2019 Summer France Expo. There are many ...",time:"Sep.  12 . 2017"},
        {imgPath:require("../assets/news.png"),title:"Shuai Fu participated in the 2019 Summer France Expo...",content:"Shuaifu participated in the 2019 Summer France Expo. There are many ...",time:"Sep.  12 . 2016"}
      ],
      src:require('../assets/right.png'),
      navList:[
        "CORPORATE INFORMATION ",
        "INDUSTRY NEWS"
      ],
      bannerHeightT:'',
      bannerHeight:'',
      select:0,
      imgPath:[],
      imgPathT:[
        require("../assets/construction-2578410.png"),
        require("../assets/construction-2578410.png"),
        require("../assets/construction-2578410.png")
      ]
    }
  },
  components:{
    firstComponent,footComponent,BtnComponent
  },
  mounted(){
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.$nextTick(()=>{
      this.getList()
      if(this.$i18n.locale==='en'){
        this.getPro('23')
        this.getNews('9')
      }else{
        this.getPro('36')
        this.getNews('11')
      }

    })
    // scrollbar.scrollTo(0,0)
  },
  methods:{
    changeNews(index){
      this.select=index
      if(index===0){
        if(this.$i18n.locale==='en'){
          this.getNews(9)
        }else{
          this.getNews(11)
        }
      }else{
        if(this.$i18n.locale==='en'){
          this.getNews(10)
        }else{
          this.getNews(12)
        }
      }
    },
    gotoNews(id){
      this.$router.push({path:'/newsInfo',query:{id:id}})
    },
    getNews(id){
        const url = `${getNewsUrl( this.$i18n.locale,id,100,1)}`
        this.$axios.get(url).then(res => {
          this.newsList=res.data.newsArr
        })
    },
    getPro(id){
        const url = `${getProductstypeUrl2( this.$i18n.locale,id)}`
        this.$axios.get(url).then(res => {
          this.proList=res.data
        })
    },
    getList(){
        const url = `${getPicUrl( 'zh-CN','首页banner',17)}`
        this.$axios.get(url).then(res => {
          this.imgPath=res.data
        })
    },
    gotoTop(){
      Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
    },
    gotoPro(id,index){
      this.$router.push({path:'/product',query:{id:id,select:index}})
    },
    goto(){
      // this.$refs['vs'].scrollIntoView('#num2', 500);
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      setup(lang);
      // location.reload() // 为了重新实例化vue-router对象，避免一些bug
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
.mainCon{
  width:100%;
}
.banner,.visio{
  width:100%;
  position: relative;

}
.visio img{
  width:100%;
}
  .navImg{
    width:100%;
    height:100vh;
    object-fit: cover;
  }
  .text{
    width:70%;
    z-index: 999;
    position: absolute;
    margin-top:460px;
    margin-left: 16.5%;
  }
  .visioText{
    width:22%;
    z-index: 999;
    position: absolute;
   top:30%;
    right:10%;
    background-color: white;
    opacity: 0.95;
    border-radius: 5px;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
  }
  .visioText p{
    text-align: left;
    line-height: 30px;
  }
  .visioTitle{
    font-size: 35px;
    font-weight: bold;
    color:#C9382C;
  }
  .text p{
    text-align: left;
    letter-spacing: 1px;
  }
  .bigText{
    font-size: 25px;
    color:white;
    font-weight: bold;
  }
  .smallText{
   color: #f0f0f0;
    font-size: 20px;
    font-weight: bold;
  }
  .about{
    width:1280px;
    margin: 0 auto;
    padding-top: 60px;
    display: flex;
    flex-direction: row;
    padding-bottom: 60px;
  }
  .about img{
    transition: all 2s;
  }
  .about img:hover{
    transform: scale(1.05);
  }
  .about .leftText{
    width:50%;
    position: relative;
  }
  .about p:hover{
    color:#C9382C;
  }
  .leftText p{
   text-align: left;
    width:80%;
    line-height: 35px;
    transition: all 2s;
  }
  .firstP{
    font-size: 18px;
    font-weight: bold;
    margin-top: 50px;
  }
.firstCon{
  display: flex;
  flex-direction: column;
}
.title{
  font-size: 25px;
  font-weight: bold;
  color:black;
  text-align: left;
}
.firstLine{
  position: relative;
  width:200px;
  height:2px;
  background-color: #E3E3E3;
  margin-top: 25px;
}
.firstLine span{
  display: inline-block;
  height:2px;
  width:50px;
  background-color: #C9382C;
  position: absolute;
  left: 0;
}
  .product{
    width:90%;
    margin-left: 5%;
    padding-top: 30px;
    margin-top: 30px;
  }
  .productTitle{
    text-align: center;
    font-size: 28px;
    font-weight: bold;
  }
  .line{
   width:120px;
    height:2px;
    background-color: #E3E3E3;
    margin: 0 auto;
    position: relative;
  }
  .line span{
    display: inline-block;
    position: absolute;
    width:30%;
    background-color: red;
    height:2px;
    left: 35%;
  }
  .fiveImg{
    width:100%;
    margin-top: 60px;
    display: flex;
    flex-direction: row;
  }
.leftImg{
  width:26%;
}
.a{
  margin-left: 4%;
}
.centerCon{
  width:40%;
  background: url("../assets/main.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 10px;
  cursor: pointer;
  position: relative;
}
.centerCon p:first-child{
  margin-top: 37%;
}
.leftCon{
  width:95%;
  position: relative;
  height:300px;
  margin:0 2.5%;
  cursor: pointer;
}
.leftCon:before{
  position: absolute;
  background-color: #E7BBB8;
  top:10px;
  left: 0;
  width:100%;
  height:290px;
  display: inline-block;
  content: '';
  opacity: 0;
  z-index: 2;
  transition: all 2s;
}
.centerCon:before{
  position: absolute;
  background-color: #E7BBB8;
  top:0px;
  left: 0;
  width:100%;
  height:100%;
  display: inline-block;
  content: '';
  opacity: 0;
  z-index: 0;
  transition: all 2s;
}
.centerCon:hover::before{
  opacity: 0.4;
}
.leftCon:hover::before{
  opacity: 0.4;
}
.leftCon:hover .btn{
  opacity: 1;
}
.centerCon:hover .btn{
  opacity: 1;
}
.centerCon .btn{
  margin-top: 0px;
}
.btn{
  margin-top: 30px;
  opacity: 0;
  transition: all 2s;
}
  .leftCon img{
    position: absolute;
    left: 0;
    width:100%;
    height:95%;
    top:4%;
  }
  .leftConText{
    position: absolute;
    z-index: 999;
    top:22%;
    left: 8%;
    display: flex;
    flex-direction: column;
  }
.leftConText p:first-child,.centerCon p:first-child{
  font-size: 18px;
  font-weight: bold;
}
  .leftConText .aText{
    font-size: 12px;
  }
  .leftConText span{
    background-color: #FAFAFA;
    color:black;
    font-weight: bold;
    padding: 10px 10px;
    border-bottom: 2px solid red;
    cursor: pointer;
    margin-top: 40px;
  }
  .newsBtn{
    background-color: #FAFAFA;
    color:black;
    font-weight: bold;
    padding: 10px 25px;
    border-bottom: 2px solid red;
    cursor: pointer;
    margin-top: 40px;
  }
  .newsCon{
    width:1280px;
    margin: 60px auto;
  }
.select{
  width:100%;
  display: flex;
  flex-direction:row;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
.select ul{
  width:60%;
  list-style: none;
  padding-inline-start: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.select ul li{
  color:black;
  font-weight: bold;
  cursor: pointer;
  position: relative;
  height:60px;
  display: flex;
}
.select ul li span{
  transition:color 2s;
  -webkit-transition:color 2s ;
  letter-spacing: 1px;
}
.select ul li img{
  width:16px;
  height:16px;
  margin-top: 2px;
  position: absolute;
}
.redLine{
  position: absolute;
  bottom: 0;
  width:0;
  height:2px;
  background-color:#C9382C;
  left: 50%;
  display: none;
  animation: myMove .5s linear forwards;
  transform: translate(-50%);
}
@keyframes myMove {
  from {width:0;}
  to {width:100%;}
}
@-webkit-keyframes mymove /*Safari 和 Chrome*/{
  from {width:0;}
  to {width:100%;}
}
.select ul li:hover .redLine,.select ul li:hover{
  display: block;
  color:#C9382C;
}
.select ul li:hover img{
  transform:rotate(90deg);
  -ms-transform:rotate(90deg); /* Internet Explorer */
  -moz-transform:rotate(90deg); /* Firefox */
  -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
  -o-transform:rotate(90deg); /* Opera */
  -webkit-transition:-webkit-transform 1s linear;
  transition:transform 1s linear;
}
  .newsMain{
    width:1280px;
    margin: 60px auto;
    display: flex;
    flex-direction: row;
  }
  .newsItem{
    width:20%;
    margin-left: 4%;
    overflow: hidden;
    cursor: pointer;
    padding-bottom: 10px;
    position: relative;
  }
  .newsItem img{
    width:100%;
    transition: all 2s;

  }
  .newsItem p{
    text-align: left;
    line-height: 25px;
    padding-left: 5%;
    padding-right: 5%;
    transition: all 2s;
  }
  .newsTitle{
    font-weight: bold;
  }
  .newsTime{
    font-weight: bold;
    font-size: 14px;
  }
.newsContent{
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.newsItem::before{
  display: inline-block;
  content: '';
  width:0;
  height:2px;
  background-color: #C9382C;
  transition: all 2s;
  position: absolute;
  bottom:0;
  left:0;
}
.newsItem:hover::before{
  width:100%;
}
.newsItem:hover img{
  transform: scale(1.1);
}
.newsItem:hover p{
  color:#C9382C;
}
.five{
  width:1280px;
  margin: 40px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 80px;
  flex-wrap: wrap;
} .it2 img{
    transition: all 2s;
  max-width: 80%;
  object-fit: contain;
  }
.it2 img:hover{
  transform: scale(1.05);
}
.it2{
  border: 1px solid #DBDBDB;
  width:18%;
  padding-top: 10px;
  margin-bottom: 30px;
}

@media screen and (max-width: 1680px){
  .text{
    margin-top: 350px;
  }
.leftCon{
  height:250px;
}
  .leftCon::before{
    height:238px;
  }
}
@media screen and (max-width: 1440px){
  .leftCon{
    height:228px;
  }
  .leftCon::before{
    height:218px;
  }
  .text{
    margin-left: 15.5%;
    margin-top: 400px;
  }
  .visioText{
    width:31%;
  }

}

@media only screen and (min-width: 1921px) and (max-width: 4000px){
  .leftCon{
    height:385px;
  }
  .leftCon::before{
    height:375px;
  }
}

@media screen and (max-width:450px){
  .mainCon{
    overflow: hidden;
  }
  .text{
    margin-left: 5%;
    width:90%;
    margin-top: 350px;
  }
  .bigText{
    width:50% !important;
    font-size:20px;
  }
  .smallText{
    font-size: 14px;
  }
  .btn{
    margin-top: 0;
  }
  .about{
    width:100%;
    flex-wrap: wrap;
    padding-bottom: 0;
  }
 .about .leftText{
   width:90%;
   margin-left: 5%;
 }
 .about .leftText p{
   width:100%;
 }
 .about img{
   width:95%;
   object-fit: cover;
   margin-left: 2.5%;
 }
 .product{
   margin-top: 0;
 }
 .productTitle{
   font-size: 25px;
 }
 .fiveImg{
   display: flex;
   flex-direction: column;
 }
 .leftImg{
   width:100%;
   margin-left: 0;
 }
 .leftCon{
   margin: 0;
   width:100%;
 }
 .centerCon{
   width:100%;
 }
 .newsCon{
   width:100%;
 }
 .newsMain{
   width:100%;
   display: flex;
   flex-direction: column;
 }
 .newsItem{
   width:100%;
   margin-left: 0;
 }
 .five{
   width:100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
 }
 .it2{
   width:100%;
   margin-top: 20px;
 }
 .select ul{
   width:80%;
 }
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue